import {
  PROJECT_NAV_GROUPS,
  LIBRARIES_NAV_GROUPS,
  SALES_NAV_GROUPS,
  PURCHASES_NAV_GROUPS,
  USER_NAV_GROUPS,
} from "./navGroups.constants"

const NAVBAR_CONFIG_BY_ROUTE = [
  {
    match: ({ pathname }) => pathname === "/onboarding",
    navGroups: [],
    listTitleKey: "Bienvenida",
    detailTitleKey: "Bienvenida",
    showBackButton: false,
    showCloudCheck: false,
    showHeaderOptions: false,
    forceNavigation: false,
  },
  {
    match: ({ pathname }) =>
      pathname === "/contacts" || pathname.startsWith("/contacts/"),
    navGroups: [],
    listTitleKey: "Contactos",
    detailTitleKey: "Contactos",
    showBackButton: false,
    showCloudCheck: false,
    showHeaderOptions: false,
    forceNavigation: false,
  },
  {
    match: ({ pathname }) =>
      USER_NAV_GROUPS.some(group => pathname.startsWith(group.to)),
    navGroups: USER_NAV_GROUPS,
    listTitleKey: "Ajustes",
    detailTitleKey: "Ajustes",
    showBackButton: false,
    showCloudCheck: false,
    showHeaderOptions: true,
    forceNavigation: true,
  },
  {
    match: ({ pathname, projectId }) =>
      !projectId &&
      (pathname.startsWith("/expenses") ||
        pathname.startsWith("/purchase-orders") ||
        pathname.startsWith("/purchase-order/")),
    navGroups: PURCHASES_NAV_GROUPS,
    listTitleKey: "Compras",
    detailTitleKey: "Compras",
    showBackButton: false,
    showCloudCheck: false,
    showHeaderOptions: false,
    forceNavigation: true,
  },
  {
    match: ({ pathname, projectId }) =>
      !projectId &&
      (pathname.startsWith("/invoices") || pathname.startsWith("/invoice/")),
    navGroups: SALES_NAV_GROUPS,
    listTitleKey: "Ventas",
    detailTitleKey: "Ventas",
    showBackButton: false,
    showCloudCheck: false,
    showHeaderOptions: false,
    forceNavigation: true,
  },
  {
    match: ({ pathname }) => pathname.startsWith("/bancodeprecios"),
    navGroups: LIBRARIES_NAV_GROUPS,
    listTitleKey: "Librerías",
    detailTitleKey: "Librerías",
    showBackButton: false,
    showCloudCheck: false,
    showHeaderOptions: false,
    forceNavigation: true,
  },
]

const DEFAULT_NAVBAR_CONFIG = {
  navGroups: PROJECT_NAV_GROUPS,
  listTitleKey: "Proyectos",
  detailTitleKey: "Proyecto",
  showBackButton: true,
  showCloudCheck: true,
  showHeaderOptions: true,
  forceNavigation: false,
}

export { NAVBAR_CONFIG_BY_ROUTE, DEFAULT_NAVBAR_CONFIG }
